<template>
  <Icon :component="DownloadSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import DownloadSvg from './svg/DownloadSvg.vue';

export default defineComponent({
  name: 'DeleteIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      DownloadSvg: markRaw(DownloadSvg)
    };
  }
});
</script>
